<template>
	<section class="m-public-bg m-index">
		<div class="m-breadcrumb-wrap">
			<MBreadcrumb name="所有測試" :show-back="false" />
		</div>
		<!-- 轮播 -->
		<VanBanner :data="banners" />
		<!-- 首页排行榜 -->
		<section class="m-rank">
			<CsRank />
			<WeeklyRecommendSection :data="recommend" title="本週推薦" :schannel="'calc-weekly-m'" />
			<PaidTestSection :data="emotion" title="付費測試" :schannel="'calc-emotion-m'" />
		</section>
		<!-- 老师测试精选 -->
		<ClientOnly>
			<!-- <TeacherList /> -->
			<!-- 主题分类 -->
			<ThemeCs />
		</ClientOnly>
		<FreeFunTestSection />
	</section>
</template>

<script setup>
import { getResourse } from "~/api/api";
import { removeDomain } from "~/utils/common";
import { ref } from "vue";

// 组件
import CsRank from "./components/cs-rank/index.vue";
import PaidTestSection from "./components/paid-test-section/index.vue";
import WeeklyRecommendSection from "./components/weekly-recommend-section/index.vue";
// import TeacherList from "./components/teacher-list/index.vue";
import ThemeCs from "./components/theme-cs/index.vue";
import VanBanner from "./components/van-banner/index.vue";
import FreeFunTestSection from "./components/free-fun-test-section/index.vue";

const props = defineProps({
	channel: {
		type: String,
		default: "",
	},
});

// banner
const { data: banners } = await useLazyAsyncData(
	"onlinecs-banners",
	async () => {
		try {
			const res = await getResourse({ class: 98 });
			return res.data.map(v => ({
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			}));
		} catch (error) {
			console.error("加载轮播图失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 本周推荐
const { data: recommend } = await useLazyAsyncData(
	"onlinecs-recommend",
	async () => {
		try {
			const res = await getResourse({ class: 100 });
			return res.data.map(v => {
				return {
					...v,
					jump_url: removeDomain(v.actioncontent.global_type),
				};
			});
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 情感专栏
const { data: emotion } = await useLazyAsyncData(
	"onlinecs-emotion",
	async () => {
		try {
			const res = await getResourse({ class: 99 });
			return res.data.map(v => {
				return {
					...v,
					jump_url: removeDomain(v.actioncontent.global_type),
				};
			});
		} catch (error) {
			console.error("加载数据失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

// 组件挂载时执行客户端特定逻辑
onMounted(async () => {
	// 埋点事件（仅客户端执行）
	try {
		logEvent("site_calc_uv");
	} catch (error) {
		console.error("埋点事件发送失败:", error);
	}
});
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
	display: none;
	width: 0;
	height: 0;
	color: transparent;
}
.m-index {
	display: flex;
	flex-direction: column;
	padding-bottom: 30px;
	overflow: hidden;

	.m-breadcrumb-wrap {
		padding: 24px 32px;
		background-color: #fff;
		border-top: 1px solid #efefef;
	}

	.m-rank {
		margin-top: 48px;
		padding: 0 32px;
	}
}
</style>
